import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

export interface ToastConfig {
  message: string;
  type?: 'success' | 'error' | 'warning' | 'info';
  duration?: number;
}

export interface Toast extends ToastConfig {
  id: number;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private _toasts = new Subject<Toast>();
  private _dismiss = new Subject<number>();
  private nextId = 0;

  get toasts$(): Observable<Toast> { return this._toasts.asObservable(); }
  get dismiss$(): Observable<number> { return this._dismiss.asObservable(); }

  show(config: ToastConfig) {
    const id = this.nextId++;
    const toast: Toast = { id, type: 'info', duration: 3000, ...config };
    this._toasts.next(toast);

    if (toast.duration && toast.duration > 0) {
      setTimeout(() => this._dismiss.next(id), toast.duration);
    }
  }

  dismiss(id: number) {
    this._dismiss.next(id);
  }
}
